import { useAuthStore } from '@neuroforge/shared/client'
import type { QueryClient } from '@tanstack/react-query'

import { authContextChanged, isPublicQuery } from './auth-query-policy'

/**
 * Un seul abonnement par QueryClient, installé avant le bootstrap. Annulation
 * d'abord, suppression synchrone ensuite : une réponse A tardive ne peut pas
 * alimenter le nouvel observer B (les fetch non abortables peuvent continuer
 * sur le réseau, mais leur Query a été retirée du cache).
 */
export function installAuthQueryIsolation(client: QueryClient): () => void {
  return useAuthStore.subscribe((current, previous) => {
    if (!authContextChanged(previous, current)) return

    const predicate = (query: { queryKey: readonly unknown[]; state: { data: unknown } }) =>
      !isPublicQuery(query.queryKey, query.state.data)

    void client.cancelQueries({ predicate })
    client.removeQueries({ predicate })
    // Retirer les états de mutation d'une autre session. Les callbacks
    // optimistes doivent également comparer leur principal avant un rollback.
    client.getMutationCache().clear()
  })
}
